if (!customElements.get('menu-drawer')) {
  class MenuDrawer extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details');
      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.bindEvents();
    }

    bindEvents() {
      this.querySelectorAll('summary').forEach(summary =>
        summary.addEventListener('click', this.onSummaryClick.bind(this))
      );

      this.querySelectorAll('button').forEach(button =>
        button.addEventListener('click', this.onCloseButtonClick.bind(this))
      );
    }

    onKeyUp(event) {
      if (event.code === 'Escape') {
        this.closeMenuDrawer();
      }
    }

    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) {
          this.closeMenuDrawer();
        }
      });
    }

    onSummaryClick(event) {
      const summary = event.currentTarget;
      const details = summary.closest('details');

      if (details.hasAttribute('open')) {
        event.preventDefault();
        this.closeMenuDrawer();
      } else {
        this.openMenuDrawer(details);
      }
    }

    onCloseButtonClick(event) {
      event.preventDefault();
      this.closeMenuDrawer();
    }

    openMenuDrawer(details) {
      details.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
    }

    closeMenuDrawer() {
      if (this.mainDetailsToggle) {
        this.mainDetailsToggle.removeAttribute('open');
      }
      document.body.classList.remove('overflow-hidden');
    }
  }

  customElements.define('menu-drawer', MenuDrawer);
}
